const namespace = 'transactions';

export const GET_TRANSACTION = `${namespace}/Get`;
export const GET_TRANSACTION_SUCCESS = `${namespace}/Get Success`;
export const GET_TRANSACTION_FAIL = `${namespace}/Get Fail`;
